import { connect } from 'react-redux';
import { trackDomEvent } from 'common/src/app/actions/trackingActions';
import DomEventTracker from './DomEventTracker';

export default connect(null, { trackDomEvent })(DomEventTracker);
